/*
 * Transforms the snapshot to make it easier to work with in the application.
 */
export default function transformEventSnapshot(eventSnapshot) {
  return {
    ...eventSnapshot,
    siteEditor: {
      ...eventSnapshot.siteEditor,
      // Remove eventData from event.siteEditor read only state so it is not used as write.
      eventData: null
    }
  };
}
